module.exports = __webpack_public_path__ + "669b561618d077aa47d9b92317ca9647.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/XtnaTrabajoChart.png
// module id = 2810
// module chunks = 1